import { clearSettlement, settleMethod } from '@wix/premium-fed-sdk/@apis-infra';
import { useEffect, useRef } from 'react';
export const useSettledMethods = function (settlements, enabled) {
  if (enabled === void 0) {
    enabled = true;
  }
  const initialized = useRef(false);
  const settlementsRef = useRef(settlements);
  settlementsRef.current = settlements;
  useEffect(() => {
    return () => {
      if (initialized.current) {
        settlementsRef.current.forEach(_ref => {
          let methodConfig = _ref.methodConfig;
          return clearSettlement(methodConfig);
        });
        initialized.current = false;
      }
    };
  }, []);
  if (enabled && !initialized.current) {
    settlements.forEach(_ref2 => {
      let methodConfig = _ref2.methodConfig,
        data = _ref2.data;
      return settleMethod(methodConfig, data, {
        ttlMs: Infinity
      });
    });
    initialized.current = true;
  }
};
export const useSettledMethod = function (methodConfig, data, enabled) {
  if (enabled === void 0) {
    enabled = true;
  }
  useSettledMethods([{
    methodConfig,
    data
  }], enabled);
};
//# sourceMappingURL=useSettledMethod.js.map